<template>
    <div>
        <download-qrcode :qrCodeForm="qrCodeForm" :showQrcode="showQrcode" />
    </div>
</template>
<script>
import downloadQrcode from '@/components/common/downloadQrcode';
export default {
    components: {
        downloadQrcode
    },
    data() {
        return {
            showQrcode: true,
            qrCodeForm: {
                enterpriseId: JSON.parse(localStorage.getItem("loginData")).enterpriseId,
                storeId: JSON.parse(localStorage.getItem("loginData")).storeId,
            }
        }
    },
    created() {

    }
}
</script>

